import React, { useCallback, useMemo } from 'react';
import appStoreBadge from '@/assets/download-on-apple-app-store-badge-dark.svg';
import googlePlayBadge from '@/assets/download-on-google-play-badge-dark.svg';
import { Box, Flex, Text } from 'rebass';
import Button from '../../../components/Button/Button';
import { FaGoogle, FaKey } from 'react-icons/fa';
import { useGoogleLogin, useGoogleOneTapLogin } from '@react-oauth/google';
import { loginWithGoogle, authenticateWithPasskey } from '@/services/auth';

const ExternalAuthButtons = () => {
  const oauthState = useMemo(() => crypto.randomUUID(), []);

  const _googleLogin = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
    redirect_uri: `${window.location.origin}/login/google`,
    state: oauthState,
  });
  const googleLogin = useCallback(() => {
    sessionStorage.setItem('google-oauth-state', oauthState);
    _googleLogin();
  }, [oauthState, _googleLogin]);

  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      loginWithGoogle({ credential: credentialResponse.credential });
    },
  });

  return (
    <Flex
      flexDirection="column"
      sx={{
        gap: 3,
        justifyContent: 'stretch',
        alignItems: 'stretch',
        alignContent: 'stretch',
        marginTop: 5,
      }}
    >
      <Flex alignItems="center" width="100%" px={3} mb={1}>
        <Box sx={{ flex: 1, height: '1px', bg: 'gray' }} />
        <Text sx={{ px: 3, color: 'gray', fontSize: 1 }}>or</Text>
        <Box sx={{ flex: 1, height: '1px', bg: 'gray' }} />
      </Flex>
      <Button
        textAlign="center"
        variant="secondary"
        title="Login with Google"
        onClick={googleLogin}
        width="100%"
        justifyContent="center"
        paddingY={3}
      >
        <FaGoogle style={{ margin: 0 }} />
        <Text ml={2} style={{ marginTop: 1 }}>
          Login with Google
        </Text>
      </Button>
      <Button
        variant="secondary"
        title="Login with Apple"
        onClick={() => authenticateWithPasskey(false)}
        width="100%"
        justifyContent="center"
        paddingY={3}
      >
        <FaKey style={{ margin: 0 }} />
        <Text ml={2} style={{ marginTop: 1 }}>
          Login with Passkey
        </Text>
      </Button>
      <Flex
        flexDirection="column"
        alignItems="center"
        alignSelf="center"
        sx={{
          maxWidth: 300,
          mt: 5,
          pt: 4,
          gap: 2,
        }}
      >
        <Text sx={{ color: 'gray', fontSize: 1, textAlign: 'center' }}>
          Try our mobile app for backflow testing in the field with full offline
          support!
        </Text>
        <Flex
          flexWrap="wrap"
          justifyContent="center"
          sx={{ gap: 2 }}
        >
          <a
            href="https://apps.apple.com/us/app/ecosconnect/id1575097014"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={appStoreBadge}
              alt="Download on the App Store"
              style={{ height: 40 }}
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.ecosconnect.mobile"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={googlePlayBadge}
              alt="Get it on Google Play"
              style={{ height: 40 }}
            />
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ExternalAuthButtons;
